import * as store from '@daas-consulting/core-frontend-store';

export const context = 'security';
export const feature = 'authentication';
export const name = store.getName({ context, feature });
